import { axiosPrivate } from "../config/axios";
import { errorApi, successApi } from "./handle.response.api";

export const getDetailCustomerApi = async (customerId: string) => {
  try {
    const res = await axiosPrivate.get(`/customers/${customerId}`);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi(
      "Lấy chi tiết khách hàng thất bại",
      error?.response?.data?.message
    );
  }
};
export const getStatisticCustomerApi = async (
  customerId: string,
  dateFrom: string
) => {
  try {
    const res = await axiosPrivate.get(
      `/customers/statistic/${customerId}?dateFrom=${dateFrom}`
    );
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi(
      "Lấy chi tiết khách hàng thất bại",
      error?.response?.data?.message
    );
  }
};

// export const getDetailTripApi = async (tripId: string) => {
//   try {
//     const res = await axiosPrivate.get(`/trips/${tripId}`);
//     return successApi(res?.data);
//   } catch (error: any) {
//     return errorApi("Lấy chi tiết thất bại", error?.response?.data?.message);
//   }
// };
